import { render, staticRenderFns } from "./PresentationWatch.vue?vue&type=template&id=084ec3ec&scoped=true&"
import script from "./PresentationWatch.vue?vue&type=script&lang=js&"
export * from "./PresentationWatch.vue?vue&type=script&lang=js&"
import style0 from "./PresentationWatch.vue?vue&type=style&index=0&id=084ec3ec&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "084ec3ec",
  null
  
)

export default component.exports